import { render, staticRenderFns } from "./AppealRecordTranscriptAppRightToAppealPg.vue?vue&type=template&id=6f83cc06&scoped=true"
import script from "./AppealRecordTranscriptAppRightToAppealPg.vue?vue&type=script&lang=ts"
export * from "./AppealRecordTranscriptAppRightToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f83cc06",
  null
  
)

export default component.exports